/*
 * Copyright (c) 2014-2023 Inovalon, Inc. All Rights Reserved.
 * This computer program is CONFIDENTIAL and a TRADE SECRET of Inovalon, Inc.
 * The receipt or possession of this program does not convey any rights to use, reproduce or disclose
 * its contents in whole or in part, without the specific written consent of Inovalon, Inc.
 * Any use, reproduction or disclosure of this program without the express written consent of Inovalon, Inc.
 * is a violation of the copyright laws and may subject you to criminal prosecution.
 */
import React from 'react'
import { Route, RouteComponentProps } from 'react-router-dom'
import { injectProperty, container } from '../../arc/configuration/ServiceLocator'
import { ITopNavBarApiClient } from '../../services/TopNavBarApiClient/contracts'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import BootstrapTable from 'react-bootstrap-table-next'
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone, PaginationTotalStandalone } from 'react-bootstrap-table2-paginator'
import { Label, Input, Button, ModalFooter, Modal, ModalBody, Row, ModalHeader, Spinner, FormFeedback } from 'reactstrap'
import { IImportBatchUIStateManager } from '../../services/ImportBatchUIStateManager/contracts'
import './ImportBatchUI.scss'
import sampleBatch from '../../files/SampleBatch.xlsx'

import { observer, Observer } from 'mobx-react'
import ReactExport from 'react-export-excel'
import { ValidationMessage, MessageTypes } from '../ValidationMessage/ValidationMessage'
import { isEmpty } from 'validator'

export interface IImportBatchUIProps extends RouteComponentProps {
	ImportBatchUIStateManager: IImportBatchUIStateManager
}

export interface IImportBatchUIState {
	successRowsData: any
	errorRowsData: any
	modal: any
	fade: any
	modalForError: any
	fadeForError: any
	resultMessage: any
	errorRows: any
	isLoading: boolean
	page: any
	data: any
	totalSize: any
	sizePerPage: any
	fileName: any
	alldata: any
	IsPageLoading: boolean
	ExcelContent: any
	isSearching: boolean
	isExporting: boolean
	isProcessing: boolean
	showErrorMessage: boolean
	errorMessage: string
	errorFileName: string
	inputKey: any
	isFileInvalid: boolean
}
const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

@observer
export class ImportBatchUI extends React.Component<IImportBatchUIProps, IImportBatchUIState> {
	@injectProperty('ITopNavBarApiClient')
	public topNavBarApiClient!: ITopNavBarApiClient
	private buttonRef: React.RefObject<HTMLButtonElement>
	constructor(props) {
		super(props)

		this.state = {
			modal: false,
			fade: false,
			modalForError: false,
			fadeForError: false,
			resultMessage: '',
			errorRows: null,
			isLoading: false,
			page: 1,
			data: [],
			totalSize: '',
			sizePerPage: 10,
			fileName: '',
			alldata: [],
			successRowsData: [],
			errorRowsData: [],
			IsPageLoading: false,
			ExcelContent: null,
			isSearching: false,
			showErrorMessage: false,
			errorMessage: '',
			isExporting: false,
			isProcessing: false,
			errorFileName: '',
			inputKey: Date.now(),
			isFileInvalid: true,
		}
		this.handleTableChange = this.handleTableChange.bind(this)
		this.buttonRef = React.createRef()
	}

	NoDataIndication = (): any => (
		<div className="no-data">
			{this.state.isLoading ? (
				<Spinner animation="border" role="status">
					<span className="sr-only">Loading...</span>
				</Spinner>
			) : (
				<span>No result found</span>
			)}
		</div>
	)

	setAsyncState = newState => new Promise(resolve => this.setState(newState, resolve))

	componentDidMount(): void {
		this.toggleValidationMessageShow = this.toggleValidationMessageShow.bind(this)
	}

	toggleValidationMessageShow(): void {
		this.setState({
			inputKey: Date.now(),
			showErrorMessage: !this.state.showErrorMessage,
			errorMessage: '',
		})
	}

	handleTableChange = (type, { page, sizePerPage, sortField, sortOrder }) => {
		const currentIndex = (page - 1) * sizePerPage

		setTimeout(() => {
			let result = this.state.alldata
			// Handle column sort
			if (sortOrder === 'asc') {
				result = result.sort((a, b) => {
					if (a[sortField] > b[sortField]) {
						return 1
					} else if (b[sortField] > a[sortField]) {
						return -1
					}
					return 0
				})
			} else {
				result = result.sort((a, b) => {
					if (a[sortField] > b[sortField]) {
						return -1
					} else if (b[sortField] > a[sortField]) {
						return 1
					}
					return 0
				})
			}
			this.setState(() => ({
				page,
				data: result.slice(currentIndex, currentIndex + sizePerPage),
				totalSize: result.length,
				sizePerPage,
			}))
		}, 300)
	}

	setDataToInitial() {
		if (this.props.ImportBatchUIStateManager.rowErrorsCount === 0) {
			this.setSuccessfulRowsToInitialState()
			this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.fileName = null
			this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.File = null
		}
	}

	HandleClick() {
		if (this.props.ImportBatchUIStateManager.validateSelectedRequestDetail.isAllFieldsValid()) {
			this.setState({ isSearching: true, showErrorMessage: false })
			this.props.ImportBatchUIStateManager.saveOrUpdateSelectedItem()
				.then(() => {
					if (isEmpty(this.props.ImportBatchUIStateManager.batchDetail.batchName) || this.props.ImportBatchUIStateManager.batchDetail.batchName === null) {
						this.setState({
							errorFileName: 'ExportedError_' + this.props.ImportBatchUIStateManager.batchDetail.fileName + '_' + new Date().toISOString().substr(0, 10),
						})
					} else {
						this.setState({
							errorFileName: 'ExportedError_' + this.props.ImportBatchUIStateManager.batchDetail.batchName + '_' + new Date().toISOString().substr(0, 10),
						})
					}

					this.setState({
						IsPageLoading: false,
						modalForError: this.props.ImportBatchUIStateManager.rowErrorsCount > 0,
						resultMessage: this.props.ImportBatchUIStateManager.resultMessage,
						errorRows: this.props.ImportBatchUIStateManager.rowErrorsCount,
						alldata: this.props.ImportBatchUIStateManager.coverageDiscoveryBatchResponseGridErrorResultList.coverageDiscoveryBatchResponseGridErrorResultCollection,
						data: this.props.ImportBatchUIStateManager.coverageDiscoveryBatchResponseGridErrorResultList.coverageDiscoveryBatchResponseGridErrorResultCollection,
						successRowsData: this.props.ImportBatchUIStateManager.successRowsForExport,
						errorRowsData: this.props.ImportBatchUIStateManager.erroroneousRowsForExport,
						totalSize: this.props.ImportBatchUIStateManager.coverageDiscoveryBatchResponseGridErrorResultList.errorCount,
						modal: false,
						isFileInvalid: true,
					})
				})
				.then(() => {
					this.props.ImportBatchUIStateManager.isRequestRaisedForImport = false
					this.props.ImportBatchUIStateManager.rowErrorsCount === 0 && this.props.history.push('/batches')
				})
				.then(() => {
					this.setState({
						isSearching: false,
					})
				})
				.catch(error => {
					this.props.ImportBatchUIStateManager.isRequestRaisedForImport = false
					console.log(error)
					this.setState({
						isSearching: false,
						showErrorMessage: true && !isEmpty(error.toString()),
						errorMessage: error.toString(),
						isFileInvalid: true,
					})
				})
		}
	}

	toggle(event: any): void {
		this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.batchName = ''
		event.preventDefault()
		this.setState({
			modal: !this.state.modal,
		})
		if (this.state.modal === false) {
			this.props.ImportBatchUIStateManager.isRequestRaisedForImport = false
		}
	}

	toggleModalForError(event: any) {
		this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.batchName = ''
		this.props.ImportBatchUIStateManager.erroroneousRowsForExport = []
		this.props.ImportBatchUIStateManager.rowErrorsCount = 0
		this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.fileName = null
		this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.File = null

		event.preventDefault()

		this.setState({
			modalForError: !this.state.modalForError,
			modal: false,
			page: 1,
			sizePerPage: 10,
			totalSize: '',
		})

		if (this.state.modalForError === false) {
			this.props.ImportBatchUIStateManager.isRequestRaisedForImport = false
		}
	}

	CancelBatchUpload(event: any) {
		this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.batchName = ''
		this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.File = null
		this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.fileName = null
		this.toggle(event)
		this.setState({
			showErrorMessage: false,
			isFileInvalid: true,
		})
	}

	SendSucessData() {
		this.setState({ isProcessing: true, modal: false })
		this.props.ImportBatchUIStateManager.erroroneousRowsForExport = []
		this.props.ImportBatchUIStateManager.rowErrorsCount = 0
		this.props.ImportBatchUIStateManager.sendSucessfulRows()
			.then(() => {
				this.setState({
					isProcessing: false,
					modalForError: this.state.isExporting === true ? true : false,
				})
				this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.File = null
				this.setSuccessfulRowsToInitialState()
			})
			.then(() => {
				this.props.ImportBatchUIStateManager.isRequestRaisedForImport = false
				this.props.history.push('/batches')
			})
			.catch(error => {
				this.props.ImportBatchUIStateManager.isRequestRaisedForImport = false
				alert(error)
				this.setState({
					modalForError: false,
					isProcessing: false,
					isExporting: false,
				})
				this.setSuccessfulRowsToInitialState()
			})
	}
	setSuccessfulRowsToInitialState() {
		this.props.ImportBatchUIStateManager.coverageDiscoveryImportBatchUIResponse.successfulRows = []
		this.props.ImportBatchUIStateManager.coverageDiscoveryImportBatchUIResponse.successfulRowsCount = 0
		this.props.ImportBatchUIStateManager.successRowsForExport = []
	}
	onExportToExcel(event: any): any {
		event.preventDefault()
		this.setState({
			isExporting: true,
		})
		this.setAsyncState({
			ExcelContent: this.state.errorRowsData,
		})
			.then(() => {
				if (this.buttonRef.current) {
					this.buttonRef.current.click()
				}
			})
			.then(() => {
				this.setState({
					isExporting: false,
				})
			})
	}

	render(): React.ReactNode {
		return (
			<div className="batchCd">
				<div className="col-md-12">
					<a id="batchButton" href="/coveragediscovery/batches">
						Batch History
					</a>
					<a onClick={e => this.toggle(e)} id="batch-button" href="/importbatchui">
						Upload Batch
					</a>
					<a id="batch-button" target="_blank" rel="noopener noreferrer" download="SampleBatch.xlsx" href={sampleBatch}>
						Download sample file
					</a>
				</div>
				<div>
					<Modal modalClassName="import-batch-modal" isOpen={this.state.modal} fade={this.state.fade} toggle={e => this.toggle(e)} backdrop="static" style={{ height: '450px !important' }}>
						<ModalHeader>
							<div id="headerForError">
								<h1 id="batchUploadHeader">Upload Batch File</h1>
								<span id="closeModalForUpload" onClick={e => this.CancelBatchUpload(e)}>
									&times;
								</span>
							</div>
						</ModalHeader>
						<ModalBody style={{ marginTop: '40px', border: '1px groove' }}>
							<div id="formBody">
								<Row>
									<Label className="entryPrompt w-75" id="batchNameLabel">
										Batch Name
									</Label>
									<Input type="text" id="batchText" onFocus={this.removeModelPopupZIndex} onChange={e => this.props.ImportBatchUIStateManager.setSelectedItem({ ...this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest, batchName: typeof e.target.value !== 'undefined' ? e.target.value : '' })} value={typeof this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest !== 'undefined' ? this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.batchName : ''} placeholder="Enter the Batch Name" valid={this.props.ImportBatchUIStateManager.validateSelectedRequestDetail.isFieldValid('batchName')} invalid={!this.props.ImportBatchUIStateManager.validateSelectedRequestDetail.isFieldValid('batchName')}></Input>
									<FormFeedback id="feedback">{this.props.ImportBatchUIStateManager.validateSelectedRequestDetail.getMessage('batchName')}</FormFeedback>
								</Row>
								<Row>
									<Label id="batchLabel">If the Batch Name is not provided then the File Name is considered as Batch Name</Label>
								</Row>
								<Row>
									<Label className="entryPrompt w-75" id="uploadFile">
										Upload File
									</Label>
									<Input
										id="btnUpload"
										type="file"
										accept=".xlsx"
										key={this.state.inputKey}
										valid={this.props.ImportBatchUIStateManager.validateSelectedRequestDetail.isFieldValid('file')}
										invalid={!this.props.ImportBatchUIStateManager.validateSelectedRequestDetail.isFieldValid('file')}
										onChange={e => {
											this.props.ImportBatchUIStateManager.setSelectedItem({ ...this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest, fileName: e.target.files && e.target.files.length > 0 && e.target.files[0].name ? e.target.files[0].name : null })
											this.props.ImportBatchUIStateManager.setSelectedItem({ ...this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest, File: e.target.files && e.target.files.length > 0 ? e.target.files[0] : null })

											this.setState({
												showErrorMessage: false,
												isFileInvalid: this.props.ImportBatchUIStateManager.coverageDiscoveryBatchRequest.fileName === null,
											})
										}}
									/>
									<FormFeedback id="feedbackForFile">{this.props.ImportBatchUIStateManager.validateSelectedRequestDetail.getMessage('file')}</FormFeedback>
								</Row>
								<Row>
									<div>
										<ValidationMessage showValidationMessage={this.state.showErrorMessage} MessageType={MessageTypes.Error} validationMessage={this.state.errorMessage} toggleAction={this.toggleValidationMessageShow} />
									</div>
								</Row>
							</div>
						</ModalBody>
						<ModalFooter>
							{this.state.isSearching ? (
								<Button id="searchButton" color="btnSaveColor" className="btn save buttonWidth110" disabled>
									<Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
									Uploading..
								</Button>
							) : (
								<Button
									id="btnSubmit"
									disabled={this.state.isFileInvalid}
									onClick={(): void => {
										this.HandleClick()
										this.setDataToInitial()
									}}
								>
									Upload File
								</Button>
							)}{' '}
							<Button id="btnCancel" onClick={e => this.CancelBatchUpload(e)} disabled={this.state.isSearching}>
								Cancel
							</Button>
						</ModalFooter>
					</Modal>
				</div>
				<div>
					<Modal modalClassName="import-batch-modalForError" isOpen={this.state.modalForError} fade={this.state.fadeForError} toggle={e => this.toggleModalForError(e)} backdrop="static">
						<ModalHeader>
							<div id="headerForError">
								<h1 id="batchUploadHeader">Excel Validation Error</h1>
								<span id="closeModalForError" onClick={(e: React.MouseEvent<HTMLSpanElement, MouseEvent>): void => this.toggleModalForError(e)}>
									&times;
								</span>
							</div>
						</ModalHeader>
						<ModalBody>
							<div id="formBody">
								<Row>
									<Label id="labelForError">{this.state.resultMessage}</Label>
								</Row>
								<Row>
									<img alt="alert" id="alertImg" src="img/icon-alert.png"></img> <Label id="labelForMessage">Click export errors to view the invalid requests. {this.props.ImportBatchUIStateManager.rowSuccessCount !== 0 && 'Click continue to batch the valid requests.'}</Label>
								</Row>
								<div className="errorDataTable">
									<PaginationProvider
										pagination={paginationFactory({
											custom: true,
											page: this.state.page,
											sizePerPage: this.state.sizePerPage,
											totalSize: this.state.totalSize,
											showTotal: true,
											sizePerPageList: [
												{
													text: '10',
													value: 10,
												},
												{
													text: '25',
													value: 25,
												},
												{
													text: '50',
													value: 50,
												},
												{
													text: '100',
													value: 100,
												},
											],
											paginationTotalRenderer: (from: number, to: number, size: number) => (
												<span className="react-bootstrap-table-pagination-total" id="pageForError">
													{' '}
													Showing {from} to {to} of {size} Results{' '}
												</span>
											),
										})}
									>
										{({ paginationProps, paginationTableProps }: any): JSX.Element => {
											return (
												<div>
													<div className="clearfix">
														<span className="float-left" id="showPageSizeForError">
															<SizePerPageDropdownStandalone {...paginationProps} />
														</span>
														<span id="page">
															<PaginationTotalStandalone {...paginationProps} />
														</span>
														<span className="float-right" id="showPagination">
															<PaginationListStandalone {...paginationProps} />
														</span>
													</div>
													<Observer>
														{(): JSX.Element => {
															return (
																<BootstrapTable
																	keyField="id"
																	classes="dataTable"
																	bootstrap4
																	hover
																	condensed
																	remote
																	noDataIndication={(): JSX.Element => <this.NoDataIndication />}
																	onTableChange={(type: string, args: any): void => this.handleTableChange(type, args)}
																	data={this.state.data.slice()}
																	defaultSorted={[
																		{
																			dataField: 'rowNumber',
																			order: 'asc',
																		},
																	]}
																	{...paginationTableProps}
																	columns={[
																		{
																			dataField: 'rowNumber',
																			text: 'Row',
																			sort: true,
																		},
																		{
																			dataField: 'responseInformation',
																			text: 'Info',
																			sort: false,
																		},
																		{
																			dataField: 'errorMessage',
																			text: 'Error',
																			sort: false,
																		},
																	]}
																/>
															)
														}}
													</Observer>
												</div>
											)
										}}
									</PaginationProvider>
								</div>
								<div className="row text-center">
									{this.props.ImportBatchUIStateManager.isServiceDatePresent === true ? (
										<ExcelFile filename={this.state.errorFileName} element={<Button innerRef={this.buttonRef}></Button>}>
											<ExcelSheet data={this.state.ExcelContent} name="errorsheet1">
												<ExcelColumn label="Row" value="rowNumber" />
												<ExcelColumn label="ErrorMessage" value="errorMessage" />
												<ExcelColumn label="NPI" value="npi" />
												<ExcelColumn label="PracticeLocation" value="practiceLocation" />
												<ExcelColumn label="PatientLastName" value="patientLastName" />
												<ExcelColumn label="PatientFirstName" value="patientFirstName" />
												<ExcelColumn label="PatientMiddleName" value="patientMiddleName" />
												<ExcelColumn label="DateofBirth" value="dateofBirth" />
												<ExcelColumn label="Gender" value="gender" />
												<ExcelColumn label="SSN" value="ssn" />
												<ExcelColumn label="VisitRun" value="visitRun" />
												<ExcelColumn label="DateOfService" value="serviceBeginDate" />
												<ExcelColumn label="PatientAddress" value="patientAddress" />
												<ExcelColumn label="PatientAddress2" value="patientAddress2" />
												<ExcelColumn label="City" value="city" />
												<ExcelColumn label="State" value="state" />
												<ExcelColumn label="Zip" value="zip" />
												<ExcelColumn label="PatientPhone" value="patientPhone" />
												<ExcelColumn label="GuarantorFirstName" value="guarantorFirstName" />
												<ExcelColumn label="GuarantorLastName" value="guarantorLastName" />
												<ExcelColumn label="GuarantorSSN" value="guarantorSSN" />
												<ExcelColumn label="GuarantorGender" value="guarantorGender" />
												<ExcelColumn label="GuarantorDOB" value="guarantorDOB" />
												<ExcelColumn label="ClientBalance" value="clientBalance" />
												<ExcelColumn label="GuarantorAddress" value="guarantorAddress" />
												<ExcelColumn label="GuarantorAddress2" value="guarantorAddress2" />
												<ExcelColumn label="GuarantorCity" value="guarantorCity" />
												<ExcelColumn label="GuarantorState" value="guarantorState" />
												<ExcelColumn label="GuarantorZip" value="guarantorZip" />
												<ExcelColumn label="GuarantorPhoneNumber" value="guarantorPhoneNumber" />
												<ExcelColumn label="ClientField1" value="clientField1" />
												<ExcelColumn label="ClientField2" value="clientField2" />
												<ExcelColumn label="ClientField3" value="clientField3" />
												<ExcelColumn label="ClientField4" value="clientField4" />
												<ExcelColumn label="ClientField5" value="clientField5" />
												<ExcelColumn label="RunDemographics" value="runDemographics" />
											</ExcelSheet>
										</ExcelFile>
									) : (
										<ExcelFile filename={this.state.errorFileName} element={<Button innerRef={this.buttonRef}></Button>}>
											<ExcelSheet data={this.state.ExcelContent} name="errorsheet1">
												<ExcelColumn label="Row" value="rowNumber" />
												<ExcelColumn label="ErrorMessage" value="errorMessage" />
												<ExcelColumn label="NPI" value="npi" />
												<ExcelColumn label="PracticeLocation" value="practiceLocation" />
												<ExcelColumn label="PatientLastName" value="patientLastName" />
												<ExcelColumn label="PatientFirstName" value="patientFirstName" />
												<ExcelColumn label="PatientMiddleName" value="patientMiddleName" />
												<ExcelColumn label="DateofBirth" value="dateofBirth" />
												<ExcelColumn label="Gender" value="gender" />
												<ExcelColumn label="SSN" value="ssn" />
												<ExcelColumn label="VisitRun" value="visitRun" />
												<ExcelColumn label="ServiceBeginDate" value="serviceBeginDate" />
												<ExcelColumn label="ServiceEndDate" value="serviceEndDate" />
												<ExcelColumn label="PatientAddress" value="patientAddress" />
												<ExcelColumn label="PatientAddress2" value="patientAddress2" />
												<ExcelColumn label="City" value="city" />
												<ExcelColumn label="State" value="state" />
												<ExcelColumn label="Zip" value="zip" />
												<ExcelColumn label="PatientPhone" value="patientPhone" />
												<ExcelColumn label="GuarantorFirstName" value="guarantorFirstName" />
												<ExcelColumn label="GuarantorLastName" value="guarantorLastName" />
												<ExcelColumn label="GuarantorSSN" value="guarantorSSN" />
												<ExcelColumn label="GuarantorGender" value="guarantorGender" />
												<ExcelColumn label="GuarantorDOB" value="guarantorDOB" />
												<ExcelColumn label="ClientBalance" value="clientBalance" />
												<ExcelColumn label="GuarantorAddress" value="guarantorAddress" />
												<ExcelColumn label="GuarantorAddress2" value="guarantorAddress2" />
												<ExcelColumn label="GuarantorCity" value="guarantorCity" />
												<ExcelColumn label="GuarantorState" value="guarantorState" />
												<ExcelColumn label="GuarantorZip" value="guarantorZip" />
												<ExcelColumn label="GuarantorPhoneNumber" value="guarantorPhoneNumber" />
												<ExcelColumn label="ClientField1" value="clientField1" />
												<ExcelColumn label="ClientField2" value="clientField2" />
												<ExcelColumn label="ClientField3" value="clientField3" />
												<ExcelColumn label="ClientField4" value="clientField4" />
												<ExcelColumn label="ClientField5" value="clientField5" />
												<ExcelColumn label="RunDemographics" value="runDemographics" />
											</ExcelSheet>
										</ExcelFile>
									)}
								</div>
							</div>
						</ModalBody>
						<ModalFooter>
							{this.state.isExporting ? (
								<Button id="exportButton" color="btnSaveColor" className="btn save buttonWidth110" disabled>
									<Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
									Exporting..
								</Button>
							) : (
								<Button id="btnExport" type="button" onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => this.onExportToExcel(e)}>
									Export Errors
								</Button>
							)}{' '}
							{this.props.ImportBatchUIStateManager.rowSuccessCount === 0 ? null : this.state.isProcessing ? (
								<Button id="continueButton" color="btnCancelColor" className="btn cancel buttonWidth110" disabled>
									<Spinner as="span" animation="grow" size="sm" role="status" aria-hidden="true" />
									Processing..
								</Button>
							) : (
								<Button id="btnContinue" onClick={(): void => this.SendSucessData()}>
									Continue
								</Button>
							)}
						</ModalFooter>
					</Modal>
				</div>
			</div>
		)
	}

	// Specific to IE: React Model is dynamically adding the html div wrapper with z-index 1050 around the Model popup
	// Removing it dynamically keeps the UI unchanged
	removeModelPopupZIndex(): void {
		// Get all div's with tabindex -1
		const elms = document.querySelectorAll('[tabindex="-1"]')

		// Loop through them
		Array.prototype.forEach.call(elms, function(elm) {
			// tabindex divs with zIndex 1050
			if ((elm.style.zIndex = '1050')) {
				// Child element is the Import batch model popup
				if (elm.getElementsByClassName('import-batch-modal').length > 0) {
					// Reset zIndex of parent div
					elm.style.zIndex = null
				}
			}
		})
	}
}
export const ImportBatchUIConnected = (): JSX.Element => {
	const store = container.get<IImportBatchUIStateManager>('IImportBatchUIStateManager')
	return <Route exact path="/importbatchui" render={(props): JSX.Element => <ImportBatchUI {...props} ImportBatchUIStateManager={store} />} />
}
